/** Client-only prototype for encrypted key backups. Passwords are not sent to the vault. */
import { sealMeetingKey, openMeetingKey, type KeyEnvelope } from './e2ee-key-envelope.js';
const ENDPOINT='https://app.vorbello.eu/e2ee-key-vault.php';
export class EncryptedKeyVault {
  constructor(private readonly transport: typeof fetch = fetch) {}
  private async request(token: string, event: string, action: 'get' | 'put', envelope?: KeyEnvelope): Promise<KeyEnvelope | null> {
    if (!token || !/^(?:meet|room)-[a-f0-9]{32}$/.test(event)) throw new Error('Invalid vault request');
    const response = await this.transport.call(globalThis, ENDPOINT, {method:'POST',cache:'no-store',credentials:'omit',headers:{'Content-Type':'application/json',Authorization:`Bearer ${token}`},body:JSON.stringify({action,event,...(envelope ? {envelope} : {})})});
    const value: unknown = await response.json();
    if (!response.ok || !value || typeof value !== 'object' || (value as any).success !== true) {
      const code = value && typeof value === 'object' ? (value as any).code : '';
      if (code === 'key_storage') throw new Error('Directorul privat pentru chei nu este accesibil aplicației pe server.');
      if (code === 'account_storage' || code === 'account_sync') throw new Error('Datele contului nu au putut fi verificate pe server.');
      if (code === 'event_lookup') throw new Error('Întâlnirea nu a fost găsită în datele contului verificat de server.');
      if (code === 'key_operation') throw new Error('Cheia nu a putut fi citită sau salvată pe server.');
      throw new Error('Serviciul de chei nu este disponibil sau sesiunea a expirat.');
    }
    return (value as any).envelope as KeyEnvelope | null;
  }
  async backup(token:string,organization:string,event:string,key:Uint8Array,password:string): Promise<void> {
    const existing=await this.request(token,event,'get');
    if (existing) {
      const restored=await openMeetingKey(existing,password,organization,event);
      try { if (restored.length!==key.length || restored.some((v,i)=>v!==key[i])) throw new Error('Conflicting vault key'); }
      finally { restored.fill(0); }
      return;
    }
    await this.request(token,event,'put',await sealMeetingKey(key,password,organization,event));
  }
  async recover(token:string,organization:string,event:string,password:string):Promise<Uint8Array | null> {
    const existing=await this.request(token,event,'get');
    return existing ? openMeetingKey(existing,password,organization,event) : null;
  }
}
